export default "__VITE_PUBLIC_ASSET__08815eea__"